export const ZIP_CODE_REGEXP: RegExp = /^\d{5}(?:-\d{4})?$/;
export const EMAIL_REGEXP: RegExp = /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const PHONE_REGEXP: RegExp = /^\d{10}$/;
